import React from 'react';

import {
    TranslatedString,
    Dialog,
    PrimaryButton
} from '@bosch/bt-ui';

import './UserUnrecognizedWarningDialog.css';
import withErrorHandler from './ErrorHandler';

const UserUnrecognizedWarningDialog = (props) => {
    const {
        openWarning,
        descTranslatedId,
        setWarningOpen,
        onWarning = null
    } = props;

    const onCloseModal = () => setWarningOpen(false);

    return (
        <Dialog onClose={onCloseModal} 
            dialogOptions={{
                open: openWarning
            }}
            title={<TranslatedString stringId="dialog-warning" />}
            // Can be either "error", "warning", "success", "info", or "none"
            alertType="warning"
        >
            {descTranslatedId && descTranslatedId.map((desc, i) => (
                <div className="dialog-description" key={i}>
                    <TranslatedString stringId={desc} />
                </div>
                )
            )}
          
            <div className="dialog-ok-button">
                <PrimaryButton type="button" onClick={onWarning ?? onCloseModal}>
                    <TranslatedString stringId="button-ok" />
                </PrimaryButton>
            </div>
        </Dialog>
    );
}

export default withErrorHandler(UserUnrecognizedWarningDialog);